import { Instagram, Linkedin } from 'lucide-react';
import { RedditIcon, DiscordIcon } from '../icons/BrandIcons';
import {
  HUSTLANCE_INSTAGRAM_URL, HUSTLANCE_REDDIT_URL, HUSTLANCE_DISCORD_URL, HUSTLANCE_LINKEDIN_URL,
} from '../Router';
import { cn } from '../ui/utils';

export const HUSTLANCE_SOCIAL_LINKS = [
  { href: HUSTLANCE_INSTAGRAM_URL, label: 'Hustlance on Instagram', icon: Instagram },
  { href: HUSTLANCE_REDDIT_URL, label: 'Hustlance on Reddit', icon: RedditIcon },
  { href: HUSTLANCE_DISCORD_URL, label: 'Hustlance on Discord', icon: DiscordIcon },
  { href: HUSTLANCE_LINKEDIN_URL, label: 'Hustlance on LinkedIn', icon: Linkedin },
];

interface SocialIconLinksProps {
  className?: string;
  iconClassName?: string;
}

/** The exact same Hustlance social links shown in the nav bar (Instagram/Reddit/Discord/LinkedIn) — reused as-is wherever a "follow us" row is needed, instead of building separate per-article share icons. */
export function SocialIconLinks({ className, iconClassName = 'w-5 h-5' }: SocialIconLinksProps) {
  return (
    <div className={cn('flex items-center gap-4', className)}>
      {HUSTLANCE_SOCIAL_LINKS.map(({ href, label, icon: Icon }) => (
        <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="text-gray-400 hover:text-hustlance-primary transition-colors">
          <Icon className={iconClassName} />
        </a>
      ))}
    </div>
  );
}
